export default __webpack_public_path__ + "static/media/ImagenPantallas.52f26158.png";